import React from "react";
import PropTypes from "prop-types";
import Icon from "@xo-union/tk-component-icons";
import styles from "./styles.css";
var CaretIcon = function CaretIcon(_ref) {
  var direction = _ref.direction;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "caret_".concat(direction),
    size: "md"
  }));
};
process.env.NODE_ENV !== "production" ? CaretIcon.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']).isRequired
} : void 0;
export default CaretIcon;